module.exports = __webpack_public_path__ + "static/media/2018.1564bfc0.svg";